import React from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import { Col, Container, Row } from 'reactstrap';
import aboutImg from "../../../assets/kangaroo/aboutUsweb.webp"
import TimerModal from '../../../component/TimerModal/TimerModal';
import "../About.css"
const About = () => {

  return (
    <SectionContainer>
      <Container fluid>
        <Row>
          <Col >
            <BreadCrumb items={[
              { title: "HOME", link: "/" },
              { title: "ABOUT", link: "/" },
              { title: "CEO" },
            ]} instituition={false} className="" />
          </Col>
        </Row>
        <Row>
          <Col>
            <h1 className='font-level-4 lh-1 mt-3' style={{ marginBottom: "4.5rem" }}>MESSAGE FROM <br /> FOUNDER & CEO</h1>
          </Col>
        </Row>
        <Row className='align-items-center '>
          <Col lg={6} sm={12}><img src={aboutImg} className="w-100 h-100 mb-4 mb-md-0" alt="" fluid /></Col>
          <Col lg={6} sm={12}>

            <p className='about-intro-font '>
              Kangaroo Education & Visa Services was created to support international students after they arrive in Australia. Our focus is on clarity, compliance, and continuity — helping students navigate education, visa responsibilities, and everyday onshore requirements with confidence. We believe informed decisions and responsible guidance are essential to building a secure and successful future in Australia.</p></Col>
        </Row>
        <Row  >
          <Col style={{ marginTop: "clamp(2.5rem,6vw,6.7rem)", marginBottom: "18rem" }}>
            <p className='about-desc-font '>I warmly welcome all international students and graduates who have chosen Australia as part of their academic and professional journey. Kangaroo Education & Visa Services (KEVS) was established with a clear purpose — to support students after they arrive in Australia and help them navigate the practical, regulatory, and educational responsibilities that come with being onshore.
              <br /> <br />
              While reaching Australia is an important milestone, the journey does not end there. Students often face new challenges related to visa conditions, education progression, health cover, and financial compliance. KEVS exists to provide reliable, accurate, and responsible guidance at these critical stages, ensuring students can move forward with confidence and clarity. <br /> <br />

              Our onshore presence in Sydney, Adelaide, and Hobart allows us to work closely with students and respond to their needs in a timely and personalised manner. We focus on understanding each individual’s situation before offering guidance, because onshore decisions often carry direct compliance implications and long-term consequences. <br /> <br />

              Integrity, transparency, and accountability remain at the core of our work. We do not believe in shortcuts or unrealistic assurances. Instead, we are committed to helping students understand their options, obligations, and next steps clearly — so they can make informed decisions that protect their future in Australia. <br /> <br />

              It gives me great pride to see students progress confidently through their onshore journey with the right support in place. I invite you to engage with KEVS as your trusted onshore partner, and allow us to support you with clarity, care, and responsibility at every step.
              <br /> <br />
              <span className='fw-bold'>Mahesh Babu Timalsina </span> Founder & CEO</p>
          </Col>
        </Row>

      </Container>
    </SectionContainer>
  )
}

export default About
